import React from 'react';
import generateYoutubeUrlPrefix from '../../../utilities/general-utilities';

const YoutubeVideo = (props) => {
  const {
    youtubeVideoTitle,
    id,
    autoplay = true,
  } = props;
  return (
    <div className="embed-responsive embed-responsive-16by9">
      <iframe
        title={youtubeVideoTitle}
        className="embed-responsive-item"
        width="100%"
        height="auto"
        src={`${generateYoutubeUrlPrefix(id)}?rel=0&autoplay=${autoplay ? '1' : '0'}`}
        frameBorder="0"
        allow={`${autoplay ? 'autoplay;' : ''} encrypted-media;`}
        allowFullScreen
      />
    </div>
  );
};

export default YoutubeVideo;
